import type { AxiosResponse } from "axios";

import { AxiosInstance } from "api";

export const removeAppointment = (id: number): Promise<AxiosResponse> => AxiosInstance.delete(`appointments/${id}`);
